import amplitude from 'amplitude-js';
import appboy from 'appboy-web-sdk/appboy.core.min';
import fetchUser from './fetchUser';
import qs from 'qs';
import trackAnalytics, {initialize, isOptedOut} from './trackAnalytics';

type RevenueAnalyticsEvent = AnalyticsEvent & {
    revenue: number;
    currencyCode: number;
    productId: number;
    plan: string;
}

export default async function trackRevenueAnalytics<T extends RevenueAnalyticsEvent>(
    name: T['analyticsEventName'],
    properties: Omit<T, 'analyticsEventName'>
) {

    await initialize();
    const {upgrade} = qs.parse(window.location.search);
    if (isOptedOut(await fetchUser())) { return; }
    if (properties && properties.revenue && properties.productId) {
        const revenue = new amplitude.Revenue().setProductId(String(properties.productId))
            .setPrice(properties.revenue).setQuantity(1);
        //log amplitude
        amplitude.getInstance().logRevenueV2(revenue);
        //log braze
        let plan = properties.plan;
        if (upgrade === 'True') {
            /*True is a string in the URL.
            Upgrade is either True or False*/
            plan = plan + '_upgrade';
        }
        appboy.logPurchase(plan, properties.revenue, properties.currencyCode, 1, {upgrade});
    }
    trackAnalytics(name, properties);
}
